import { lazy, Suspense } from 'react';
import { Routes, Route, Link } from 'react-router-dom';
import Layout from '@/components/Layout';
import ErrorBoundary from '@/components/ErrorBoundary';

const HomePage = lazy(() => import('@/pages/HomePage'));
const AboutPage = lazy(() => import('@/pages/AboutPage'));
const GalleryPage = lazy(() => import('@/pages/GalleryPage'));

function Loading() {
  return (
    <div
      role="status"
      aria-label="Loading"
      className="flex min-h-[40vh] items-center justify-center"
    >
      <div className="h-8 w-8 animate-spin rounded-full border-4 border-[var(--border)] border-t-[var(--brand-500)]" />
    </div>
  );
}

function NotFound() {
  return (
    <div
      role="alert"
      className="flex min-h-[50vh] flex-col items-center justify-center text-center"
    >
      <p className="text-6xl font-bold text-[var(--brand-400)]">404</p>
      <h2 className="mt-4 text-2xl font-bold text-[var(--text-primary)]">Page not found</h2>
      <p className="mt-2 text-[var(--text-body)]">
        The page you&rsquo;re looking for doesn&rsquo;t exist.
      </p>
      <Link
        to="/"
        className="mt-6 rounded-[var(--radius)] bg-[var(--brand-500)] px-5 py-2.5 text-sm font-semibold text-[var(--brand-text)] hover:bg-[var(--brand-600)]"
      >
        Back to Home
      </Link>
    </div>
  );
}

function App() {
  return (
    <ErrorBoundary>
      <Layout>
        <Suspense fallback={<Loading />}>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/gallery" element={<GalleryPage />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </Suspense>
      </Layout>
    </ErrorBoundary>
  );
}

export default App;
